import React from 'react';
import Header from 'pages/catalog/Header';
import Categories from 'pages/catalog/Categories';
import Promos from 'pages/catalog/Promos';
import Styles from 'pages/catalog/Styles';
import { PageWrapper, CatalogMainWrapper } from 'styles/pages/catalog';

const Catalog = () => (
  <PageWrapper>
    <Header />
    <CatalogMainWrapper>
      <Promos />
      <Categories />
      <Styles />
    </CatalogMainWrapper>
  </PageWrapper>
);

export default Catalog;
